/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { striked } from 'src/components/LandingPage/ServicePlans/ServicePlans.module.scss';

export const StringField = ({ value, description, className = '', colSpan = 1 }) => {
  if (!value) return <td colSpan={colSpan} className={[value === '' ? striked : '', className].join(' ')} />;
  return (
    <td
      colSpan={colSpan}
      className={className}
      style={{
        textAlign: 'center',
      }}
    >
      <strong>{value}</strong>
      {description && (
        <>
          <br />
          <small>{description}</small>
        </>
      )}
    </td>
  );
};
